import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

// Material Dashboard context
import { MaterialUIControllerProvider } from 'context';

// ✅ YENİ
import { AppStateProvider } from 'shared/appState/AppStateProvider';
import { MeProvider } from 'core/me/provider/MeProvider';
import { CompanySettingsProvider } from 'core/companySettings/provider/CompanySettingsProvider';
import { GlobalToaster } from 'shared/ui/GlobalToaster';
// ✅ React Query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <AppStateProvider>
          <MeProvider>
            <CompanySettingsProvider>
              <>
                <App />
                <GlobalToaster />
              </>
            </CompanySettingsProvider>
          </MeProvider>
        </AppStateProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
